<template>
  <div class="project-selector">
    <input type="hidden" name="projects" v-model="selectProjects.length" />
    <div
      class="project-box row m-0 p-0"
      v-if="projects && selectProjects"
      :class="{ notActive: !!disabled }"
    >
      <div class="col-7 p-0 list-height">
        <div class="head row p-0 m-0">
          <div class="project-search input-group col-8 p-2">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              :placeholder="$t('feature.article.setting.project_search')"
              v-model="searchProject"
            />
          </div>
          <div class="filter col-4">
            <div class="dropdown">
              <button
                class="sc-btn dropdown-toggle"
                type="button"
                id="dropdown-project-type"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ filterProjectType.name || "ทุกประเภท" }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdown-project-type">
                <li
                  class="dropdown-item"
                  v-for="(type, index) in projectTypes"
                  :key="index"
                  @click="filterProjectByProjectType(type)"
                >
                  {{ type.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="projects col">
          <div class="all pointer" @click="selectProjectAll()">
            {{ $t("label.select_all") }}
          </div>
          <div
            class="group-wrapper"
            v-for="(group, groupName) in projectGroups"
            :key="groupName"
          >
            <div class="project-group" @click="selectProjectGroup(groupName)">
              {{ groupName }} - {{ group.length }} โครงการ
            </div>
            <div
              class="project"
              v-for="project in group"
              :key="project.projectId"
              @click="selectProject(project)"
            >
              {{ project.projectCode }} - {{ project.projectName }}
            </div>
          </div>
        </div>
      </div>
      <div class="results-panel col-5 p-0 list-height" v-if="selectProjects">
        <div class="media projects-head">
          <div class="projects-counter media-body">
            เลือกแล้ว {{ selectProjects.length }} โครงการ
          </div>
          <div class="projects-remove mt-1 pointer" v-if="!disableDeleteAll" @click="removeProjectAll()">
            ลบทั้งหมด
          </div>
        </div>
        <div class="project-select col px-0">
          <div
            class="media tag"
            v-for="(selectProject, index) in selectProjects"
            :key="selectProject.projectId"
            :class="classList(selectProject)"
          >
            <div class="media-body">
              {{ selectProject.projectCode }} - {{ selectProject.projectName }}
            </div>
            <div class="ml-3" v-if="(selectProject.hasSelected === false)" @click="removeProject(index)">
              <img src="/static/icons/close.svg" alt="remove" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "bootstrap";
import { convertCamelToSnake } from '../util';

export default {
  props: ["value", "disabled", "disableDeleteAll"],
  data() {
    return {
      filterProjectType: { key: "", name: "ทุกประเภท" },
      projects: [],
      projectGroups: {},
      projectTypes: [
        { key: "", name: "ทุกประเภท" },
        { key: "H", name: "แนวสูง" },
        { key: "L", name: "แนวราบ" }
      ],
      searchProject: "",
      selectProjects: [],
      initSelected: [],
    };
  },
  watch: {
    value() {
      this.mapInputProjects();
    },
    searchProject() {
      this.buildProjectGroups();
    }
  },
  computed: {
    inputProjects() {
      return this.value;
    },
    filteredProjects() {
      const filtered = this.projects.filter(pj => {
        return (
          pj.projectName.indexOf(this.searchProject) > -1 ||
          pj.projectCode
            .toLowerCase()
            .indexOf(this.searchProject.toLowerCase()) > -1
        );
      });

      if (this.filterProjectType && this.filterProjectType.key !== "") {
        return filtered.filter(pj => {
          return pj.projectType === this.filterProjectType.key;
        });
      }

      return filtered;
    },
  },
  methods: {

    classList(currentProject) {
      return { "disable-content": currentProject.hasSelected };
    },
    getProjects() {
      const data = { searchText: this.searchProject };

      if (this.filterProjectType && this.filterProjectType.key) {
        data.type = this.filterProjectType.key;
      }

      axios
        .get(`${process.env.HOST}/api/admin/projects`, {
          params: data,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          }
        })
        .then(res => {
          this.projects = res.data;
          this.buildProjectGroups();

          this.$emit(
            "allProject",
            this.projects.map(
              (project) => convertCamelToSnake(project)
            )
          );
        })
        .then(() => {
          this.mapInputProjects();
        });
    },
    selectProjectAll() {
      this.selectProjects = this.filteredProjects;
      this.$emit("input", this.filteredProjects);
    },
    selectProjectGroup(name) {
      this.projectGroups[name].forEach(project => {
        if (!this.checkProjectDupicate(project)) {
          this.selectProjects = this.selectProjects.concat(project);
        }
      });
      this.$emit("input", this.selectProjects);
    },
    removeProjectAll() {
      this.selectProjects = [];
      this.$emit("input", this.selectProjects);
    },
    selectProject(project) {
      if (!this.checkProjectDupicate(project)) {
        this.selectProjects = this.selectProjects.concat(project);
        this.$emit("input", this.selectProjects);
      }
    },
    removeProject(index) {
      this.selectProjects.splice(index, 1);
      this.$emit("input", this.selectProjects);
    },
    checkProjectDupicate(project) {
      return this.selectProjects.some(pro => {
        if (pro.projectId === project.projectId) {
          return true;
        }
        return false;
      });
    },
    filterProjectByProjectType(type) {
      this.filterProjectType = type;
      this.buildProjectGroups();
    },
    mapInputProjects() {
      this.selectProjects = this.projects.filter(project => {
        return this.value.some(p => p.projectId === project.projectId);
      });
      this.selectProjects.map((project) => {
        if (this.initSelected.find(p => p.projectId === project.projectId) !== undefined) {
          project.hasSelected = true
        } else {
          project.hasSelected = false
        }

        return project
      })
    },
    buildProjectGroups() {
      this.projectGroups = {};
      this.filteredProjects.forEach(project => {
        if (!this.projectGroups[project.projectGroup]) {
          this.projectGroups[project.projectGroup] = [project];
        } else {
          this.projectGroups[project.projectGroup].push(project);
        }
      });
    }
  },
  created() {
    this.getProjects();
    this.initSelected = [...this.value]
  }
};
</script>

<style lang="scss" scoped>
.list-height {
  height: calc(100vh - 400px);
}

.project-box {
  border-radius: 15px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  max-height: calc(100vh - 400px);

  &.notActive {
    pointer-events: none;
  }
  &.error {
    border-color: $red;
  }
  .head {
    border-bottom: 1px solid #e0e0e0;
    max-height: 49px;
  }
  .results-panel {
    border-left: 1px solid #e0e0e0;

    &.no-left-border {
      border-left: none;
    }
  }
  .filter {
    padding: 6px 10px 0 0;
    text-align: right;
    border-left: 1px solid #e5e5e5;
  }
  input.form-control {
    border: none;
  }
  .dropdown {
    button {
      border: none;
    }
  }
}
.projects {
  background-color: #ffffff;
  height: calc(100% - 48px);
  padding: 10px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;

  &-counter {
    font-weight: bold;
    color: $orange;
  }
  &-head {
    padding: 10px;
    line-height: 1.7;
    border-bottom: 1px solid #e0e0e0;
  }
  &-remove {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.64;
    letter-spacing: -0.1px;
    text-align: right;
    color: #8c8786;
  }
  .all {
    font-weight: bold;
    color: $black;
    margin-bottom: 6px;
  }
}
.project {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #4a4a4a;
  padding-left: 16px;
  border-left: 1px solid #979797;

  &-group {
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
    margin: 8px 0;
  }
  &-select {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
  &:hover {
    color: $black;
  }
}
.dropdown {
  display: inline;
}
.input-group-text {
  background: none;
  border: none;
  border-radius: 25px;
  background-color: $white;
}
.tag {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px;
}

.disable-content {
  pointer-events: none;
  opacity: 0.8;
  background-color: rgb(226, 226, 226);
  border-bottom: 1px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ProjectSelector.vue